import React from 'react';
import { Spinner } from 'react-bootstrap';
import {
  CheckBoxContainer,
  FormBody,
  MessageContainer,
  ModalFormBody,
  RegisterButtonContainer,
} from '../../common/styledComponents';
import CheckBoxes from './CheckBoxes';
import SignUpButton from './FormButton';
import theme from 'shared/assets/style/theme';
import { useTheme } from 'styled-components';
import FormInputs from './FormInputs';

const FormContent = props => {
  const {
    values,
    errors,
    status,
    handleSubmit,
    setFieldValue,
    handleBlur,
    handleChange,
    handleCheckBoxToggle,
    termsAndConditionsUrl,
    privacyPolicyUrl,
    showPassword,
    showPasswordToggleHandle,
    isLandingPage,
    requireName,
    clientText,
    clientFurtherInfoText,
    isModal,
    isLoading,
    getStatusMessage,
  } = props;

  const { acceptedTerms, emailOptIn } = values;
  const BodyComponent = isModal ? ModalFormBody : FormBody;
  const { SignUp } = useTheme();

  const disabled = !acceptedTerms || isLoading;
  const formStatusMessage = getStatusMessage();
  return (
    <BodyComponent>
      <FormInputs
        requireName={requireName}
        showPasswordToggleHandle={showPasswordToggleHandle}
        setFieldValue={setFieldValue}
        errors={errors}
        handleBlur={handleBlur}
        showPassword={showPassword}
        handleChange={handleChange}
        signUpTheme={SignUp}
        values={values}
      />

      <CheckBoxContainer>
        <CheckBoxes
          handleCheckBoxToggle={handleCheckBoxToggle}
          acceptedTerms={acceptedTerms}
          privacyPolicyUrl={privacyPolicyUrl}
          termsAndConditionsUrl={termsAndConditionsUrl}
          clientText={clientText}
          clientFurtherInfoText={clientFurtherInfoText}
          emailOptIn={emailOptIn}
        />
      </CheckBoxContainer>

      {formStatusMessage && <MessageContainer success={status?.success}>{formStatusMessage}</MessageContainer>}

      <RegisterButtonContainer>
        <SignUpButton
          isLandingPage={isLandingPage}
          isDebounce={true}
          disabled={disabled}
          onClick={handleSubmit}
          textStroke={theme.palette.success[2]}
        />
      </RegisterButtonContainer>

      {isLoading && (
        <Spinner
          style={{
            position: 'absolute',
            top: '25%',
            left: '32.5%',
          }}
          animation="grow"
          className="custom-spinner"
        />
      )}
    </BodyComponent>
  );
};

export default FormContent;